var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"splash-container"},[_c('img',{staticClass:"logo-image",attrs:{"src":"/dKart.png","alt":"dKart Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }